var _rect, _path, _circle, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6C17.1 6 11.5 11.5 11.5 18.2c0 9.4 11.2 22.3 11.7 22.9.3.3.7.3 1 0 .5-.6 11.7-13.5 11.7-22.9C35.9 11.5 30.4 6 24 6z",
    fill: "#EA4335"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 5,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6c-3.3 0-6.3 1.3-8.5 3.4l8.5 8.8 8.5-8.8C30.3 7.3 27.3 6 24 6z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.4c-2.5 2.4-4 5.5-4 8.8 0 5.1 4.1 12.2 7.8 17.5L24 18.2l-8.5-8.8z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.2l8.5-8.8c-2.5-2.4-4.1-2.7-7.2-3.2L24 18.2z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapGoogle);
export default __webpack_public_path__ + "static/media/map-google.2ca97ed526df877045bfca64cb07a4d6.svg";
export { ForwardRef as ReactComponent };